import { ToggleButton as MuiToggleButton, toggleButtonClasses as MuiToggleButtonClasses } from '@mui/material';
import React, { forwardRef } from 'react';
import { SxProps } from '../../utils';

type NativeButtonProps = React.ComponentPropsWithoutRef<'button'>;

export interface ToggleButtonProps<T>
  extends Omit<NativeButtonProps, 'color' | 'disabled' | 'onChange' | 'onClick' | 'value' | 'startIcon'> {
  /**
   * Current value of the element
   */
  value: T;
  /**
   * Disables the element
   */
  disabled?: boolean;
  /**
   * Handler for when the value changes
   */
  onChange?: (event: React.MouseEvent<HTMLElement>, value: T) => void;
  /**
   * Handler for the button is clicked
   */
  onClick?: (event: React.MouseEvent<HTMLElement>, value: T) => void;
  /**
   * React component used as the icon before the text of the button
   */
  StartIcon?: React.ReactNode;
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx?: SxProps;
}

export const toggleButtonClasses = {
  selected: MuiToggleButtonClasses.selected,
};

export const ToggleButton = forwardRef(function ToggleButton<T>(
  { children, disabled, StartIcon, value, ...props }: ToggleButtonProps<NonNullable<T>>,
  ref: React.ForwardedRef<HTMLButtonElement>
) {
  return (
    <MuiToggleButton ref={ref} component="button" value={value} {...props} disabled={disabled}>
      {StartIcon && <span className="Chronoui-startIcon">{StartIcon}</span>}
      {children}
    </MuiToggleButton>
  );
});
